import React from 'react';
import BootstrapTable from '../../../components/react-bootstrap-table-next/react-bootstrap-table2';
import { MarkerData } from '../../../components/LandscapeMap/LandscapeMapTypes';
import './ListContainer.scss';

export interface ListContainerProps {
    markers: MarkerData[];
    setSelectedMarker: (markers: MarkerData[]) => void;
}

const ListContainer = (props: ListContainerProps) => {
    const columns = [
        {
            dataField: 'name',
            text: 'Name',
            sort: true,
            formatter: (cellContent: string, row: MarkerData) => (
                <div
                    className="referenced-text"
                    onClick={() => {
                        props.setSelectedMarker([row]);
                    }}>
                    {cellContent}
                </div>
            ),
        },
        {
            dataField: 'type',
            text: 'Type',
            sort: true,
        },
    ];

    return (
        <div className="list-container">
            <BootstrapTable
                striped
                bordered
                bootstrap4
                keyField="Id"
                data={props.markers}
                columns={columns}
                defaultSorted={[{ dataField: 'id', order: 'asc' }]}
                noDataIndication="No Data available"
            />
        </div>
    );
};

export default ListContainer;
